import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MsalBroadcastService,
  MsalGuard,
  MsalService,
} from '@azure/msal-angular';

import { routes } from './app.routes';
import { authInterceptor } from './auth/auth.interceptor';
import { msalGuardConfigFactory, msalInstanceFactory } from './auth/auth-config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),

    // --- Microsoft Entra ID (MSAL) ---
    { provide: MSAL_INSTANCE, useFactory: msalInstanceFactory },
    { provide: MSAL_GUARD_CONFIG, useFactory: msalGuardConfigFactory },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    // MSAL v3+ requires the instance to be initialized before first use.
    provideAppInitializer(() => inject(MsalService).instance.initialize()),
  ],
};
